import { render } from "./TestimonialView.vue?vue&type=template&id=79b84c45&scoped=true"
import script from "./TestimonialView.vue?vue&type=script&lang=js"
export * from "./TestimonialView.vue?vue&type=script&lang=js"

import "./TestimonialView.vue?vue&type=style&index=0&id=79b84c45&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b84c45"]])

export default __exports__